









































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreatePrintModal from "./createprintmodal.vue";
import EditPrintModal from "./editprintmodal.vue";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageUserRequest extends PageRequest {
  keyword: string;
  isEnable: number = 9; //nullable
}

@Component({
  components: { CreatePrintModal, EditPrintModal },
})
export default class PrintModal extends AbpBase {
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageUserRequest = new PageUserRequest();
  creationTime: Date[] = [];

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  get list() {
    return this.$store.state.printmodal.list;
  }
  get loading() {
    return this.$store.state.printmodal.loading;
  }
  create() {
    this.createModalShow = true;
  }
  isActiveChange(val: string) {
    if (val === "Actived") {
      this.pagerequest.isEnable = 1;
    } else if (val === "NoActive") {
      this.pagerequest.isEnable = 0;
    } else {
      this.pagerequest.isEnable = 9;
    }
    this.$store.commit("printmodal/setCurrentPage", 1);
    this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("printmodal/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("printmodal/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "printmodal/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.printmodal.pageSize;
  }
  get totalCount() {
    return this.$store.state.printmodal.totalCount;
  }
  get currentPage() {
    return this.$store.state.printmodal.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 70,
      align: "center",
      fixed: "left",
      title: this.L("IndexNo"),
      sortId: 0,
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 150,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length == 0 ? this.L("Unknown") : info[0].displayName,
            },
          },
          info.length == 0 ? this.L("Unknown") : info[0].displayName
        );
      },
    },
    {
      title: this.L("Name"),
      key: "name",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.name,
            },
          },
          params.row.name
        );
      },
    },
    {
      title: this.L("ModalType"),
      key: "modalType",
      width: 150,
      render: (h: any, params: any) => {
        let id = params.row.modalType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length == 0 ? this.L("Unknown") : info[0].name);
      },
    },
    {
      title: this.L("ModalInfo"),
      key: "modalInfo",
      width: 300,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.modalInfo,
            },
          },
          params.row.modalInfo
        );
      },
    },
    {
      title: this.L("IsActive"),
      width: 150,
      render: (h: any, params: any) => {
        return h("span", params.row.isEnable ? this.L("Yes") : this.L("No"));
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('printmodalDel');
        let edit = this.checkButtonAuth('printmodalEdit');
        return h("div", [
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("printmodal/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "printmodal/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    this.pagerequest.isEnable = 9;
    this.getpage();
  }
}
